var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 110 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44427 132.216C17.37 149.615 35.1486 160 55 160C74.8514 160 92.6267 149.615 102.556 132.216C112.481 114.822 112.481 94.0509 102.556 76.6528L60.7295 3.34723C58.183 -1.11575 51.817 -1.11574 49.2705 3.34724L7.44427 76.6528C-2.48142 94.0475 -2.48142 114.818 7.44427 132.216ZM43.2175 38.2219L52.1352 22.592C53.4085 20.3604 56.5916 20.3604 57.8648 22.592L92.172 82.7217C98.4749 93.7681 99.658 106.553 95.7213 118.253C95.3113 116.344 94.7385 114.391 93.9661 112.418C89.2273 100.317 78.5124 90.979 62.113 84.6613C50.8379 80.3336 43.641 73.9686 40.7166 65.7422C36.9499 55.1391 40.8841 43.5766 43.2175 38.2219ZM28.0112 64.8737L17.828 82.7217C10.0686 96.3208 10.0686 112.555 17.828 126.154C25.5873 139.754 39.4813 147.869 55 147.869C65.3072 147.869 74.9003 144.286 82.4542 137.894C83.4394 135.385 86.4901 126.198 82.7212 116.729C79.2401 107.986 70.8627 101.006 57.8203 95.979C43.0776 90.3201 33.4995 81.4856 29.3577 69.7287C28.7872 68.11 28.344 66.4879 28.0112 64.8737Z",
    fill: "#6FBCF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.62d8b0c8e433d8317e0cbf12a08e04b7.svg";
export { ForwardRef as ReactComponent };